import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import type { Maybe } from "@entrilia/shared/types";
import type { ReportField } from "../../../../../../../../../../api/types/svTypes";
import { getFieldCaption } from "../../../../../../utilities/Utilities";

interface Props {
  selectedFieldGuid: Maybe<string>;
  onSelectedFieldGuidChange: (fieldGuid: string) => void;
  calculatedFields: ReportField[];
  selectedFieldGuidError: string | undefined;
  readonly: boolean;
}
const ReferenceCalculatedFieldSelect = ({
  selectedFieldGuid,
  onSelectedFieldGuidChange,
  calculatedFields,
  selectedFieldGuidError,
  readonly,
}: Props) => {
  return (
    <FormControl error={!!selectedFieldGuidError}>
      <InputLabel id="calculation-field-label">Field</InputLabel>
      <Select
        labelId="calculation-field-label"
        label="Field"
        value={selectedFieldGuid}
        onChange={(evt) => onSelectedFieldGuidChange(evt.target.value ?? "")}
        disabled={readonly}
      >
        {calculatedFields.map((field) => (
          <MenuItem key={field.config.guid} value={field.config.guid}>
            {getFieldCaption(field)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ReferenceCalculatedFieldSelect;
